/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Go_To_ResumesInputs */

const en_jobs_go_to_resumes = /** @type {(inputs: Jobs_Go_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Resumes`)
};

const de_jobs_go_to_resumes = /** @type {(inputs: Jobs_Go_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Lebensläufen`)
};

const fr_jobs_go_to_resumes = /** @type {(inputs: Jobs_Go_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller aux CV`)
};

const es_jobs_go_to_resumes = /** @type {(inputs: Jobs_Go_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a currículums`)
};

const it_jobs_go_to_resumes = /** @type {(inputs: Jobs_Go_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai ai curriculum`)
};

const nl_jobs_go_to_resumes = /** @type {(inputs: Jobs_Go_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar CV's`)
};

const pl_jobs_go_to_resumes = /** @type {(inputs: Jobs_Go_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź do CV`)
};

const fi_jobs_go_to_resumes = /** @type {(inputs: Jobs_Go_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siirry ansioluetteloihin`)
};

const da_jobs_go_to_resumes = /** @type {(inputs: Jobs_Go_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til CV'er`)
};

const sv_jobs_go_to_resumes = /** @type {(inputs: Jobs_Go_To_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå till CV:n`)
};

/**
* | output |
* | --- |
* | "Go to Resumes" |
*
* @param {Jobs_Go_To_ResumesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_go_to_resumes = /** @type {((inputs?: Jobs_Go_To_ResumesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Go_To_ResumesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_go_to_resumes(inputs)
	if (locale === "fr") return fr_jobs_go_to_resumes(inputs)
	if (locale === "es") return es_jobs_go_to_resumes(inputs)
	if (locale === "it") return it_jobs_go_to_resumes(inputs)
	if (locale === "nl") return nl_jobs_go_to_resumes(inputs)
	if (locale === "pl") return pl_jobs_go_to_resumes(inputs)
	if (locale === "fi") return fi_jobs_go_to_resumes(inputs)
	if (locale === "da") return da_jobs_go_to_resumes(inputs)
	if (locale === "sv") return sv_jobs_go_to_resumes(inputs)
	return en_jobs_go_to_resumes(inputs)
});